<p-dialog header="Applied Amount" [(visible)]="displayAppliedAmountViewModal" [style]="{ width: '60vw' }">
    <div class="card">
        <h6 class="p-mb-0" style="float: right; padding-bottom: 10px;" *ngIf="channelName && channelName == soChannel.CREDIT_MEMO"> 
            Total Credit: {{creditMemo?.netAmount | customNumberFormat: fractionDigits | currencySymbol}} 
        </h6>
        <p-table [value]="transactions" styleClass="p-datatable-gridlines p-datatable-striped" dataKey="productId">
            <ng-template pTemplate="header">
                <tr>
                    <th>Date</th>
                    <th>RP Number</th>
                    <th *ngIf="channelName && channelName == soChannel.CREDIT_MEMO">Txn No.</th>
                    <th *ngIf="channelName && channelName == soChannel.CREDIT_MEMO">Txn Name.</th>
                    <th>Received By</th>
                    <th>{{ channelName && channelName == soChannel.CREDIT_MEMO ? 'Applied Amount' : 'Received Amount' }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-transaction let-index="rowIndex" let-expanded="expanded">
                <tr>
                    <td>{{transaction.createdDate | date: 'MM/dd/yyyy'}}</td>
                    <td>
                        <span class="p-mb-0 acc-name-popup-link" (click)="onRPNumberViewClick(transaction)">
                            {{transaction.receivedPaymentNumber}}
                        </span>
                    </td>
                    <td *ngIf="channelName && channelName == soChannel.CREDIT_MEMO">{{transaction.invoiceNumber}}</td>
                    <td *ngIf="channelName && channelName == soChannel.CREDIT_MEMO">{{transaction.transactionTypeName}}</td>
                    <td>{{transaction.createdBy}}</td>
                    <td>{{channelName && channelName == soChannel.CREDIT_MEMO ? (transaction.creditAmount | customNumberFormat: fractionDigits | currencySymbol) : (transaction.paidAmount | customNumberFormat: fractionDigits | currencySymbol)}}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="footer" let-rowData let-columns *ngIf="channelName && channelName == soChannel.CREDIT_MEMO">
                <tr style="position: sticky" class="footer-total">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>Net Applied Amount</td>
                    <td>{{ netAppliedAmount | customNumberFormat: fractionDigits | currencySymbol}}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <ng-template pTemplate="footer">
        <p-button (click)="onCloseDialog()" label="Cancel" styleClass="p-button-secondary"></p-button>
    </ng-template>
</p-dialog>

<!-- Receive payments -->
<div *ngIf="displayInvoiceReceive">
    <app-receive-payments [receivedPaymentId]="receivedPaymentId" [channelName]="channelName" [displayInvoiceReceive]="displayInvoiceReceive"
        [type]="receivePaymentDialogType" (invoiceReceiveEventEmitter)="onReceivePaymentsDialogClose($event)">
    </app-receive-payments>
</div>

<div *ngIf="displayCreditSelect">
    <app-apply-credit-memo [receivedPaymentId]="receivedPaymentId" [displayCreditSelect]="displayCreditSelect" (onCloseCreditMemoSelectionModal)="onCreditMemoDialogClose()"></app-apply-credit-memo>
</div>

<!-- Write check view -->
<ng-container *ngIf="displayWriteCheck && checkId">
    <app-write-check 
        [display]="displayWriteCheck" 
        [checkId]="checkId" 
        [checkDialogType]="checkDialogType" 
        (close)="onCloseWriteCheckDialog()">
    </app-write-check>
</ng-container>

